import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Minus",
  "use": "Minus-usage",
  "viewBox": "0.75 0.112 31.5 5.775",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0.75 0.112 31.5 5.775\" id=\"Minus\"><title>MINUS</title><path d=\"M.75.112h31.5v5.775H.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol